import React from "react";

const ChildSafety = () => {
  return (
    <div className="child-safety-container">
      <h1>Froth - Child Safety Standards</h1>

      <div className="child-safety-section">
        <h2>Our Commitment</h2>
        <p>
          Froth is committed to ensuring a safe and responsible environment for
          all users. We strictly adhere to child safety laws and actively
          prevent any form of exploitation or abuse.
        </p>
      </div>

      <div className="child-safety-section">
        <h2>Age Restriction</h2>
        <p>
          This app is designed for users aged <strong>13 and above</strong>. We
          do not collect or store data from users below this age.
        </p>
      </div>

      <div className="child-safety-section">
        <h2>Reporting & Feedback</h2>
        <p>
          We take user feedback and reports very seriously. Froth has built-in
          mechanisms to report inappropriate posts and users displaying abusive
          or harmful behavior. Our moderation team reviews all reports to
          maintain a safe community.
        </p>
      </div>

      <div className="child-safety-section">
        <h2>How to Report Abuse</h2>
        <p>
          If you encounter any inappropriate content or safety concerns, please
          report them immediately.
        </p>
        <a
          href="mailto:Public.relations@orphanboards.com?subject=Froth%20Report%20Abuse"
          className="child-safety-btn"
        >
          Report Abuse
        </a>
      </div>

      <div className="child-safety-section-2">
        <h2>Contact for Child Safety Concerns</h2>
        <p>
          If you need to reach us regarding child safety matters, please
          contact:
        </p>
        <p>
          <strong>Email: </strong>
          <a href="mailto:Public.relations@orphanboards.com">
            Public.relations@orphanboards.com
          </a>
        </p>
        <p>
          <strong>Phone:</strong> +1 (123) 456-7890
        </p>
      </div>

      <div className="child-safety-section">
        <h2>Data Collection</h2>
        <p>We collect the following user information:</p>
        <ul>
          <li> - First Name</li>
          <li> - Last Name</li>
          <li> - Email</li>
          <li> - Date of Birth (Must be 13 years or older)</li>
          <li> - Gender</li>
          <li> - Password</li>
        </ul>
        <p>
          All collected data is securely stored and not shared with third
          parties without user consent.
        </p>
      </div>

      <div className="child-safety-footer">
        &copy; 2025 Froth. All Rights Reserved.
      </div>
    </div>
  );
};

export default ChildSafety;
